var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"db-item db-classification"},[_c('div',{staticClass:"db-item__title"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"text-right"},[_c('svg',{staticClass:"db__icon"},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":_vm.icon}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }